import React from "react";
import { PlaylistsView } from "../../components";

export const PlaylistsPage: React.FC = () => {
  return <PlaylistsView />;
}